'use client'
import { createContext, PropsWithChildren, useContext } from "react";

type device = 'pc' | 'mobile'
export const DecideContext = createContext<device>('pc')

export const DecideProvider = ({ children, value }: PropsWithChildren & { value: device }) => {
  return <DecideContext.Provider value={value}>
    {children}
  </DecideContext.Provider>
}

export const useDevice = () => {
  return useContext(DecideContext)
}